<template>
  <div class="px-main --dark">
    <h1 class="py-4 page-title-main" v-if="bookingTypeId === 11">
      その他予約{{ $route.query.priorityBooking === 'true' ? '(優先)' : ''}}_予約ID_{{ contractId }}
    </h1>
     <h1 class="py-4 page-title-main" v-if="bookingTypeId === 12">
      提携施設_予約ID_{{ contractId }}
    </h1>
    <h1 class="py-4 page-title-main" v-if="bookingTypeId !== 12 &&  bookingTypeId !== 11">
      {{bookingTitle}}_予約ID_{{ contractId }}
    </h1>
    <template>
        <v-tabs v-model="tab" class="mb-10 d-inline-flex t-tab-custom">
          <v-tab v-for="item in items" :key="item.title" :href="'#'+item.tabUrl" class="px-8 fz-16">
            {{ item.title }}
          </v-tab>
        </v-tabs>
        <v-tabs-items :value="tab" touchless :class="isMinScreen ? 'min-width-screen' : ''">
            <v-tab-item v-if="$route.query.tab === 'basic-information'" value="basic-information" >
                <BasicInformation v-if="tab === 'basic-information'" />
            </v-tab-item>
            <v-tab-item value="billing-statement">
                <BillingStatement v-if="tab === 'billing-statement'" :key="`billingStatementKey-${billingStatementKey}`" />
            </v-tab-item>
            <v-tab-item value="guest-details">
                <GuestDetails v-if="tab === 'guest-details'" />
            </v-tab-item>
            <v-tab-item value="rental-listing">
                <RentalListing v-if="tab === 'rental-listing'" />
            </v-tab-item>
            <v-tab-item value="parking-place">
                <ParkingPlace v-if="tab === 'parking-place'" />
            </v-tab-item>
            <v-tab-item value="operation-change-history">
                <OperationChangeHistory v-if="tab === 'operation-change-history'" />
            </v-tab-item>
            <v-tab-item v-if="bookingTypeId !== 8" value="canceled">
                <Canceled v-if="tab === 'canceled'" />
            </v-tab-item>
            <v-tab-item value="ota-info">
                <OTAInfo v-if="tab === 'ota-info' && bookingGroupId"
                  :bookingGroupId="bookingGroupId"
                  :bookingId="bookingId"
                />
            </v-tab-item>
        </v-tabs-items>
    </template>
  </div>
</template>

<script>
import BasicInformation from './basicInformation'
import BillingStatement from './billingStatement'
import Canceled from './canceled'
import GuestDetails from './guestDetails'
import OperationChangeHistory from './operationChangeHistory'
import ParkingPlace from './parkingPlace'
import RentalListing from './rentalListing.vue'
import OTAInfo from './otaInfo'
import { handlErrorView, getCopyErrorTextView } from '@/constants/functions'
import { mapMutations } from 'vuex'
import gql from 'graphql-tag'
import { BookingTypeIds } from '../../../constants/bookingType'
import { isTriplaBooking, TRIPLA_OFFICIAL_SHORT_LABEL } from '@/constants/tripla'
import { checkPermissionTab } from '../../../utils/permissions'

export default {
  name: 'ContractDetailTab',
  data () {
    return {
      contractId: this.$route.query.id,
      isMinScreen: false,
      facilityType: null,
      billingStatementKey: 0,
      booking: null,
    }
  },
  computed: {
    bookingId () {
      return parseInt(this.$route.query.id)
    },
    bookingTypeId () {
      return this.booking ? this.booking.bookingTypeId : null
    },
    type () {
      return this.booking ? this.booking.bookingType.code : null
    },
    bookingTitle () {
      if (isTriplaBooking(this.booking)) return `${TRIPLA_OFFICIAL_SHORT_LABEL}予約`
      return this.bookingTypeId === BookingTypeIds.TRIAL ? '宿泊予約' : `${this.type || ''}予約`
    },
    bookingGroupId () {
      return this.booking ? this.booking.bookingGroupId : null
    },
    items () {
      // this tab filtering was not actually implemented before TO2020-1214
      // so we will not filter the tabs based on the user's role, except otaInfo
      // we do that by setting anyRole=true
      const basicInformation = {
        title: this.$t('contractDetail.basicInformation'),
        tabUrl: 'basic-information',
        pathRoot: '/reservation/contract-detail?type=SP&tab=basic-information',
        anyRole: true,
      }
      const billingStatement = {
        title: this.$t('contractDetail.billingStatement'),
        tabUrl: 'billing-statement',
        pathRoot: '/reservation/contract-detail?type=SP&tab=billing-statement',
        anyRole: true,
      }
      const guestDetails = {
        title: this.$t('contractDetail.guestDetails'),
        tabUrl: 'guest-details',
        pathRoot: '/reservation/contract-detail?type=SP&tab=guest-details',
        anyRole: true,
      }
      const rentalListing = {
        title: this.$t('contractDetail.rentalListing'),
        tabUrl: 'rental-listing',
        pathRoot: '/reservation/contract-detail?type=OTA&tab=rental-listing',
        anyRole: true,
      }
      const parkingPlace = {
        title: this.$t('contractDetail.parkingPlace'),
        tabUrl: 'parking-place',
        pathRoot: '/reservation/contract-detail?type=OTA&tab=parking-place',
        anyRole: true,
      }
      const operationChangeHistory = {
        title: this.$t('contractDetail.operationChangeHistory'),
        tabUrl: 'operation-change-history',
        pathRoot: '/reservation/contract-detail?type=SP&tab=operation-change-history',
        anyRole: true,
      }
      const canceled = {
        title: this.$t('contractDetail.canceled'),
        tabUrl: 'canceled',
        pathRoot: '/reservation/contract-detail?type=SP&tab=canceled',
        anyRole: true,
      }
      const otaInfo = {
        title: this.$t('contractDetail.otaInfo'),
        tabUrl: 'ota-info',
        pathRoot: '/reservation/contract-detail?type=SP&tab=ota-info',
      }
      let result = []
      switch (this.facilityType) {
        case 'PT':
          result = [
            basicInformation,
            billingStatement,
            guestDetails,
            operationChangeHistory,
            canceled,
          ]
          break
        case 'CNV':
          result = [
            basicInformation,
            billingStatement,
            guestDetails,
            parkingPlace,
            operationChangeHistory,
            canceled,
          ]
          break
        default:
          result = [
            basicInformation,
            billingStatement,
            guestDetails,
            rentalListing,
            parkingPlace,
            operationChangeHistory,
            canceled,
          ]
      }
      if (this.bookingTypeId === BookingTypeIds.OTA) {
        result.push(otaInfo);
      }

      if (this.bookingTypeId === 8) {
        // ota cannot be cancelled
        result = result.filter(({ tabUrl }) => tabUrl !== 'canceled')
      }
      if (this.bookingTypeId === 12) {
        // point booking shoudn't have rental item or parking
        result = result.filter(({ tabUrl }) => tabUrl !== 'rental-listing' && tabUrl !== 'parking-place')
      }

      result = checkPermissionTab(result);

      return result
    },
    tab: {
      set (tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } })
        this.setWidthScreen()
      },
      get () {
        return this.$route.query.tab
      }
    }
  },
  watch: {
    tab (newVal) {
      if (newVal) {
        switch (newVal) {
          case 'billing-statement':
            this.billingStatementKey = this.billingStatementKey + 1
            break
          default:
            break
        }
      }
    },
    $route: {
      immediate: true,
      handler (to, from) {
        this.setDocumentTitle()
      }
    }
  },

  async created () {
    await this.getBookingList()
  },

  mounted () {
    this.getFacilityList()
    this.setWidthScreen()
  },
  methods: {
    handlErrorView,
    getCopyErrorTextView,
    ...mapMutations({
      setCopyErrorText: 'setCopyErrorText',
      setAlertSuccess: 'setAlertSuccess',
      setAlertError: 'setAlertError',
      setPermissionUser: 'setPermissionUser',
      setRoleAdminUser: 'setRoleAdminUser',
      setLoadingOverlayShow: 'setLoadingOverlayShow',
      setLoadingOverlayHide: 'setLoadingOverlayHide'
    }),
    setWidthScreen () {
      this.isMinScreen = this.tab === 'operation-change-history'
    },

    async getFacilityList () {
      await this.$apollo.query({
        query: gql`
        query ($id: Int!) {
          booking(id: $id) {
            room {
              roomType {
                facility {
                  id name type
                }      
              }    
            }
          }
        }`,
        variables: {
          id: this.bookingId,
        }
      }).then((data) => {
        const facilityType = data.data.booking.room.roomType.facility.type
        this.facilityType = facilityType
      }).catch((error) => {
        console.error(error)
      })
    },

    async getBookingList () {
      this.setLoadingOverlayShow()
      await this.$apollo
        .query({
          query: gql`query ($id: Int!) {
            booking(id: $id) {
            bookingGroupId
            bookingGroup { otaCode }
            id
            bookingTypeId 
            bookingType { id name code }
          }
        }`,
          variables: {
            id: this.bookingId,
          },
          fetchPolicy: 'no-cache'
        })
        .then((data) => {
          this.booking = data.data.booking
          this.setDocumentTitle()
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {
          this.setLoadingOverlayHide()
        })
    },
    setDocumentTitle () {
      if (this.bookingTypeId === 11) {
        this.$route.query.priorityBooking === 'true' ? document.title = 'その他予約(優先)_予約ID_' + this.contractId || '予約' : document.title = 'その他予約_予約ID_' + this.contractId || '予約'
      } else if (this.bookingTypeId === 12) {
        document.title = '提携施設_予約ID_' + this.contractId || '予約'
      } else {
        document.title = this.bookingTitle + '_予約ID_' + this.contractId
      }
    }
  },
  components: {
    BasicInformation,
    BillingStatement,
    Canceled,
    GuestDetails,
    OperationChangeHistory,
    ParkingPlace,
    RentalListing,
    OTAInfo,
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep {
    &.v-tabs-bar__content {
      background-color: var(--bg__white)
    }
     .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
    color: #aaaaaa !important;
  }
  }
  .min-width-screen {
    max-width: 80%
  }
  .fz-16 {
    font-size: 16px !important;
  }
</style>
